import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, TextField, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface InputEmailsProps {
    open: boolean;
    title: string;
    submitButtonText?: string;
    onClose: any;
    onCancel?: any;
    setEmails: any;
    emails: string;
    text: string;
    error: boolean;
}

const InputEmails: React.FC<InputEmailsProps> = ({
    open,
    title,
    submitButtonText = "Ok",
    onClose,
    onCancel,
    emails,
    setEmails,
    text = "Delivery requires emails. Please enter below, separating emails by a comma (,).",
    error=false 
}) => {
    return (
        <Dialog open={open} fullWidth maxWidth="md" onClose={onCancel}>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {title}
                {onCancel && (
                    <IconButton
                        aria-label="close"
                        onClick={onCancel}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                )}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
                    {text}
                    <TextField multiline error={error} value={emails} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setEmails(event.target.value);
                    }} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{submitButtonText}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default InputEmails;